<template>
  <div v-if="page !== PAGE.NONE">
    <login-header />
    <login-form />
  </div>
</template>

<script>
import Vue from 'vue';
import LoginHeader from './components/Header.vue';
import LoginForm from './components/Form.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { PAGE } from './enums';

export default Vue.extend({
  data: () => ({
    PAGE,
  }),

  components: {
    LoginHeader,
    LoginForm,
  },

  computed: {
    ...mapGetters(['page']),
  },

  mounted() {
    if (!window.chrome) {
      this.CHANGE_PAGE(PAGE.BROWSER_NOT_SUPPORTED);
    } else {
      this.checkStatus();
    }
  },

  methods: {
    ...mapMutations(['CHANGE_PAGE']),
    ...mapActions(['checkStatus']),
  },
});
</script>
